<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="PersonalEmailChange.saveError">
    <template slot="center">
      <el-form label-width="25%" :model="formData" :rules="rules" :ref="formRef">
        <section>
          <h4 class="section-title">{{ $t('label.current') }}</h4>

          <div class="section-items">
            <el-form-item :label="$t('label.current_email')">
              <el-col :xs="24" :md="18">
                <el-input v-model="formData.current_email" :disabled="true">
                   <template slot="append">{{ formData.email_verified ? $t('label.verified') : $t('label.not_verified') }}</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.current_password')" prop="password">
              <el-col :xs="24" :md="12">
                <nuttrema-password-input :disabled="!edit" :checkStrong="false" v-model="formData.password"></nuttrema-password-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.new') }}</h4>

          <div class="section-items">
            <el-form-item :label="$t('label.new_email')" prop="email">
              <el-col :xs="24" :md="18">
                <el-input v-model="formData.email" :disabled="!edit" auto-complete="off"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.confirm_email')" prop="confirm_email">
              <el-col :xs="24" :md="18">
                <el-input v-model="formData.confirm_email" :disabled="!edit" auto-complete="off"></el-input>
              </el-col>
            </el-form-item>

            <div class="section-help" v-if="!formData.email_verified">
              <p v-html="_markdown.renderInline($t('label.verify_email_help'))"></p>
              <p v-html="_markdown.renderInline($t('label.verify_email_note'))"></p>
            </div>
          </div>
        </section>
      </el-form>
    </template>

    <template slot="footer">
      <div class="footer-row">
        <el-button
           type="primary"
           size="small"
          :disabled="!isDataChanged"
          :loading="isSaving"
          @click="submitForm">
            {{ $t('label.save_changes') }}
        </el-button>

        <el-button type="text" size="small" @click="cancelChanges(false)">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { get, pick, clone } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';
import NuttremaPasswordInput from 'components/ui/input/nuttrema-password-input';

export default {
  name: 'form-personal-change-email',
  componentName: 'FormPersonalChangeEmail',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    PersonalProfile: {
      required: true,
      default: null,
    },
    PersonalEmailChange: {
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    NuttremaPasswordInput,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        current_email: null,
        email: null,
        confirm_email: null,
        password: null,
        email_verified: null,
      },
      rules: {
        email: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.email', true),
          },
          {
            type: 'email',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.invalid', 'label.email', true),
          },
        ],
        confirm_email: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.email', true),
          },
          {
            type: 'email',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.invalid', 'label.email', true),
          },
          {
            trigger: 'blur',
            validator: this.validateEmail,
            message: this.formatValidationMessage('validation.confirm_email_not_match'),
          },
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.password', true),
          },
        ],
      },
    };
  },
  methods: {
    validateEmail(rule, value, callback) {
      if (value !== this.formData.email) callback(new Error());
      else callback();
    },
    setFormData() {
      this.formData.current_email = get(this.PersonalProfile, 'data.email', null);
      this.formData.email_verified = get(this.PersonalProfile, 'data.email_verified', null);
    },
    getFormData() {
      return pick(this.formData, ['email', 'confirm_email', 'password']);
    },
    resetForm() {
      this.formData.email = null;
      this.formData.password = null;
      this.formData.confirm_email = null;
      this.originalData = clone(this.formData);
    },
  },
  mounted() {
    this.$on('reset', this.resetForm);
  },
  created() {
    this.stateData = this.PersonalEmailChange;
    this.formRef = 'form-my-prefferences-change-email';
    this.setFormData();
  },
  watch: {
    PersonalProfile: {
      handler: function () {
        this.setFormData();
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/change-email/form-personal-change-email.vue